import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';

import {parseData} from '../../../../helper/helper';
import {goToPage, setInfoPopUP, setCallsDetailsPopUp, setIsShowPopUp} from '../../../../PersonalAreaInvoicesSlice';
import {getCallsLogAuthAsync, getMeterParameterAsync, getEnergyBundleDetailsAsync} from '../../../../PersonalAreaInvoicesAsyncThunk';
//icons
import envelope from '../../../../icons/envelope.svg';
import arrowOpen from '../../../../icons/arrow-open.svg';
import arrowClose from '../../../../icons/arrow-close.svg';
// Collapse View display
import DisplayTitleValue from '../../../CollapseView/DisplayTitleValue/DisplayTitleValue';
import DisplayRelative from '../../../CollapseView/DisplayRelative/DisplayRelative';
import DisplayTable from '../../../CollapseView/DisplayTable/DisplayTable';
import DisplayGraph from '../../../CollapseView/DisplayGraph/DisplayGraph';
import {isMobile} from 'react-device-detect';

function ProductComponent(props) {
  const {detailsProduct, subscribers, nameProduct} = props;
  const [showFullText, setShowFullText] = useState(false);
  const [dataProduct, setDataProduct] = useState([]);
  const [isArrowOpen, setIsArrowOpen] = useState({});
  const isBundleEnergyCredit = props.isEnergy && detailsProduct?.listSubPage?.some(x => x.listDalDetailsCliSection?.some(section => section?.listCliDetail?.some(detail => detail?.isBundleEnergy)));
  const clickIconArrow = (key) => {
    setIsArrowOpen((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const clickPopUp = (data, title, type = null) => {
    props.setInfoPopUP({data, title, type});
    props.setIsShowPopUp(true);
  };

  const clickPopUpMeterParameters = (meterNumber) => {
    props.getMeterParameterAsync({meterNumber});
  };

  const clickCallDetailsButton = (subscriberNo) => {
    props.getCallsLogAuthAsync({userPhone: subscriberNo});
  };

  const bodyInfo = (detail, l, i, j, k, section) => {
    if (section.subSection == 'discount' && detail.detailStyle == 'fullPrice') {
      return;
    }
    let detailArrTableView = [];
    if (detail.colomnTitle1) detailArrTableView.push({title: detail.colomnTitle1, value: detail.colomn1});
    if (detail.colomnTitle2) detailArrTableView.push({title: detail.colomnTitle2, value: detail.colomn2});
    if (detail.colomnTitle3) detailArrTableView.push({title: detail.colomnTitle3, value: detail.colomn3});

    let listCli = detail?.listChildCliDetail?.length > 1 ? detail?.listChildCliDetail : detail?.listCliSubDetail;
    const listCliDate = listCli?.map((item, i) => {
      const colomn1 = item.colomn1;
      const colomn2 = item.colomn2;
      const title = item.title;
      const price = item.amountData;
      const isGraph = item?.isGraph;
      return {
        title,
        price,
        isGraph,
      };
    });

    function goToEnergyInvoice(){
      props.getEnergyBundleDetailsAsync('energyInvoice');
    }

    const hasGraph = listCliDate?.some((item) => item.isGraph);
    return (
      <div key={`${i}-${j}-${k}-${l}`} className={`wrapper-row-info ${detail.haveFitcher ? 'haveFitcher' : ''}`}>
        <div className='row-type-product'>
          <div className={`wrapper-info-product ${detail?.detailStyle === 'discount' ? 'discount' : ''}`}>
            {detail && <div className='name-product'>{detail?.subTitle === null ? detail?.title : detail?.subTitle}
              {detail?.isBundleEnergy && !props.isEnergy && <button className='energy-link' onClick={() => goToEnergyInvoice()}>לחשבונית חשמל</button>}
            </div>}
            <div className='price-arrow'>
              <div className='wrapper-price'>
                {detail?.amountData && (
                  <>
                    ₪{detail?.amountData?.amount}.{detail?.amountData?.amountAgorot}
                    {detail?.amountData?.isAmountMinus ? <div className='price-range'>-</div> : <div className='price-range'></div>}
                  </>
                )}
                {listCli?.length > 0 ||
                detail?.isRelative ||
                detail?.isGraph ||
                hasGraph ||
                (section?.isColumnView && (detail.colomn1.trim() !== '' || detail.colomn2.trim() !== '')) ? (
                  <button className='button-arrow' onClick={() => clickIconArrow(`${i}-${j}-${k}-${l}`)}>
                    <Image src={isArrowOpen[`${i}-${j}-${k}-${l}`] ? arrowClose : arrowOpen} alt='arrow' />
                  </button>
                ) : (
                  <div className='button-width-no-arrow'></div>
                )}
              </div>
            </div>
          </div>
          {isArrowOpen[`${i}-${j}-${k}-${l}`] && detail?.listCliSubDetail?.length > 0 && !section?.isColumnView && (
            <div className='collapse-view'>
              <DisplayTitleValue nameProduct={nameProduct} detail={listCli}></DisplayTitleValue>
            </div>
          )}
          {isArrowOpen[`${i}-${j}-${k}-${l}`] && detail.isRelative && (
            <div className='collapse-view'>
              <DisplayRelative detail={detail} nameProduct={nameProduct} />
            </div>
          )}
          {isArrowOpen[`${i}-${j}-${k}-${l}`] && section?.isColumnView && (
            <div className='collapse-view'>
              <DisplayTable data={detail} nameProduct={nameProduct} detailArr={detailArrTableView} />
            </div>
          )}
          {isArrowOpen[`${i}-${j}-${k}-${l}`] && (hasGraph || detail?.isGraph) && (
            <div className='collapse-view'>
              <DisplayGraph detail={detail} nameProduct={nameProduct} />
            </div>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (detailsProduct) {
      const {data, listRequestText, listPlanDtlText, isCalllogsExists, userPhone} = parseData(detailsProduct);
      const parsedData = displayHtml(data, listRequestText, listPlanDtlText, isCalllogsExists, userPhone, detailsProduct.meterParameters);
      setDataProduct(parsedData);
    }
  }, [detailsProduct, isArrowOpen, props.showPopup, showFullText]);

  const displayHtml = (data, listRequestText, listPlanDtlText, isCalllogsExists, userPhone, meterParameters) => {
    const arrayMes = listRequestText?.flat();
    const firstMessage = arrayMes?.length > 0 ? arrayMes[0] : '';

    const continueMessage = (bool) => {
      setShowFullText(bool);
    };

    return data?.map((item, i) => (
      <div key={i} className='body-info'>
        <div className='wrapper-data-product'>
          {(item.detailsType?.toUpperCase() === 'CELLULAR' || item.detailsType?.toUpperCase() === 'ABROAD' || item.detailsType?.toUpperCase() === 'ENERGY') && (
            <div className='wrapper-row-title'>
              {userPhone && <div className='name-type'><span>{item.detailsType === 'ENERGY' ? 'מספר מונה' : 'מנוי'}</span> {userPhone}</div>}
              <div className='personal-information'>
                <div className='wrapper-link'>
                  {nameProduct?.toUpperCase() === 'ENERGY' &&
                    <button onClick={() => clickPopUpMeterParameters(userPhone)} className='link'>
                      נתוני מונה
                    </button>
                  }
                  {listPlanDtlText?.length > 0 && (
                    <button onClick={() => clickPopUp(listPlanDtlText, 'התוכנית שלך')} className='link'>
                      התוכנית שלך
                    </button>
                  )}
                  {isCalllogsExists && (
                    <button onClick={() => clickCallDetailsButton(userPhone)} className='link'>
                      פירוט שיחות
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
        {listRequestText?.length > 0 && item.listDalDetailsCliSection?.some(section => section.subSection === 'recurrent_charge') && (
            <div className='fieldset'>
              <div className='legend'>
                <Image src={envelope} alt='icon' width='50' height='50' />
                <div className='num'>{arrayMes.length > 1 ? arrayMes.length : ''}</div>
              </div>
              <div className='message-content'>
                <div className='section'>
                  <div>
                    {!isMobile
                      ? firstMessage.length <= 250
                        ? firstMessage
                        : showFullText
                        ? firstMessage
                        : `${firstMessage.substring(0, 250)}...`
                      : firstMessage.length <= 100
                      ? firstMessage
                      : showFullText
                      ? firstMessage
                      : `${firstMessage.substring(0, 100)}...`}
                  </div>
                  {showFullText && <div className='hr-section'></div>}
                </div>

                {showFullText &&
                  arrayMes.slice(1).map((message, index) => (
                    <div key={index} className='section'>
                      <div>{message}</div>
                      {index !== arrayMes.slice(1).length - 1 && <div className='hr-section'></div>}
                    </div>
                  ))}
                {(!isMobile ? firstMessage.length > 260 || arrayMes?.length > 1 : firstMessage.length > 100 || arrayMes?.length > 1) &&
                  (!showFullText ? (
                    <button className='request-btn' onClick={() => continueMessage(true)}>
                      המשך הודעה
                    </button>
                  ) : (
                    <button className='request-btn' onClick={() => continueMessage(false)}>
                      סגירה
                    </button>
                  ))}
              </div>
            </div>
          )}
          {item.listDalDetailsCliSection?.map((section, j) => (
            <div key={j} className='all-details-product'>
              <div className='wrapper-body-details'>
                <div className='title-details'>
                  {section?.title}
                  {item.detailsType == 'ABROAD' && <span className='vat-exemption'>(פטור ממע״מ)</span>}
                  {item.isCustomerBusiness && <span className='vat-exemption'>(לפני מע״מ)</span>}
                </div>
                {section?.data?.map((item, k) =>
                  item?.listFitcherDetail
                    ? item?.listFitcherDetail?.map((detail, l) => bodyInfo(detail, l, i, j, k, section))
                    : bodyInfo(item, null, i, j, k, section),
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    ));
  };

  return (
    <div className='container-body-info'>
      {(nameProduct?.toUpperCase() === 'CELLULAR' || nameProduct?.toUpperCase() === 'ENERGY' || nameProduct?.toUpperCase() === 'ABROAD') && subscribers?.length > 1 && (
        <div className='purple-line'></div>
      )}
      <div className='wrapper-body'>
        {dataProduct}
        {detailsProduct && subscribers.length > 1 && (
          <div className='footer-subscribers-cellular'>
            <hr className='hr-border-top'></hr>
            <div className='wrapper-total'>
              <div>סה״כ</div>
              {isBundleEnergyCredit ? <>₪{detailsProduct.pageTotal.price}</> :
              detailsProduct.amountData && (
                <>
                  ₪{detailsProduct.amountData.amount}.{detailsProduct.amountData.amountAgorot}
                  {detailsProduct.amountData.isAmountMinus ? '-' : ''}
                </>
              )}
            </div>
          </div>
        )}
        {nameProduct?.toUpperCase() === 'ENERGY' && detailsProduct.listCommentText?.length > 0 && (
          <button onClick={() => clickPopUp(detailsProduct.listCommentText, 'הערות')} className='link note-link'>
            <Image src={require('../../../../icons/note-icon.svg')} className='note-icon' alt='note-icon' />
            הערות
          </button>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isEnergy: state.personalAreaInvoicesPage.isEnergy
});

const mapDispatchToProps = {
  goToPage,
  setInfoPopUP,
  getCallsLogAuthAsync,
  setCallsDetailsPopUp,
  setIsShowPopUp,
  getMeterParameterAsync,
  getEnergyBundleDetailsAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductComponent);
